export default function isMobileBrowser() {
  return (
    ('ontouchstart' in window || navigator.maxTouchPoints > 0) &&
    window.innerWidth < 1280 // If there are large touchscreen desktops
  );
}
